<template>
  <div>
    <mu-bottom-sheet :open.sync="show" class="more-info-sheet">
      <header class="sheet-header">
        <span>更多信息</span>
        <div class="icon" @click="close">
          <img src="./assets/close.svg" />
        </div>
      </header>
      <Form ref="sheetForm" :model="model">
        <FormItem
          :field="{
            label: '单位地址',
            style: 'align-items: flex-start;',
            labelStyle: 'position: relative; top: 2px;',
          }"
          prop="organization_address"
        >
          <TextareaItem
            key="enterprise"
            v-model="modelData.organization_address"
            v-bind="{
              placeholder: '填写单位地址',
            }"
          />
        </FormItem>
        <FormItem
          :field="{ label: '单位电话' }"
          prop="organization_tel"
          :rules="telRules"
        >
          <InputItem
            key="enterprise"
            v-model="modelData.organization_tel"
            v-bind="{ placeholder: '填写单位电话' }"
          />
          <!-- :value="modelData.organization_tel"
           @input="handlerTel" -->
        </FormItem>
        <FormItem
          :field="{ label: '银行账号' }"
          :rules="bankCodeRules"
          prop="bank_account"
        >
          <InputItem
            key="enterprise"
            v-model="modelData.bank_account"
            v-bind="{ placeholder: '填写银行账号' }"
          />
        </FormItem>
        <FormItem :field="{ label: '开户银行' }" prop="bank_name">
          <InputItem
            key="enterprise"
            v-model="modelData.bank_name"
            v-bind="{ placeholder: '填写银行信息' }"
          />
        </FormItem>
      </Form>
      <footer class="sheet-footer">
        <ForchangeButton class="confirm-btn" active @click.stop="confirm"
          >确认</ForchangeButton
        >
      </footer>
    </mu-bottom-sheet>
  </div>
</template>

<script>
import InputItem from '../Input/ForchangeInput.vue';
import TextareaItem from '../Input/ForchangeTextarea.vue';
import FormItem from '../Form/FormItem.vue';
import ForchangeButton from '../Button/button.vue';
import Form from '../Form/Form.vue';

export default {
  components: {
    // eslint-disable-next-line vue/no-reserved-component-names
    Form,
    InputItem,
    FormItem,
    ForchangeButton,
    TextareaItem,
  },

  model: {
    prop: 'model',
    event: 'updateModelData',
  },

  props: {
    model: {
      type: Object,
      default: function () {
        return {};
      },
    },

    open: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      modelData: {},
      templateModelData: {},
      first: true,
      show: this.open,
      bankCodeRules: [
        { validate: this.checkBank, message: ' 银行账号格式错误' },
      ],
      telRules: [{ validate: this.handlerTel, message: ' 电话号码格式错误' }],
    };
  },

  computed: {
    // templateModelData: {
    //   get() {
    //     console.log('get.....', this.model);
    //     return Object.assign({}, this.model);
    //   },
    //   set(newValue) {
    //     console.log('set.....', newValue);
    //     this.updateModelData(Object.assign({}, newValue));
    //   },
    // },
  },

  watch: {
    open(val) {
      this.show = val;
    },

    show(val) {
      this.$emit('update:open', val);
    },

    model: {
      handler(newValue, oldValue) {
        this.modelData = newValue;
      },
      deep: true,
      immediate: true,
    },

    modelData: {
      handler(newValue, oldValue) {
        this.updateModelData(newValue);
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    close() {
      this.show = false;
    },

    handlerTel(telNo) {
      const telRule = /^([0-9\-\+\(\)])+$/;
      const newTelNo = '';
      if (!telNo) return true;
      this.modelData.organization_tel = telNo;
      if (telRule.test(telNo)) {
        return true;
      } else {
        return false;
      }
    },

    confirm() {
      this.$refs.sheetForm.validate().then((result) => {
        if (result) {
          this.show = false;
          this.$emit('changeMoreInfo', { ...this.modelData });
        }
      });
    },

    checkBank(bankNo) {
      // 参考https://kf.qq.com/faq/170112ABnm6b170112FvquAn.html
      const bankNo_pattern = /^\d{8,30}$/;
      // 替换空格
      const _bankNo = bankNo && bankNo.replace(' ', '');

      if (!_bankNo) {
        return true;
      }
      return bankNo_pattern.test(_bankNo);
    },

    updateModelData(value) {
      this.$emit('updateModelData', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.more-info-sheet {
  padding: 0 0 24px;
  background-color: #fff;
  border-top-left-radius: 32px;
  border-top-right-radius: 32px;
  .sheet-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 38px 40px 31.5px;
    color: #383333;
    font-weight: normal;
    font-size: 34px;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    .icon {
      width: 33px;
      height: 33px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .sheet-footer {
    margin: 0 40px;
    padding: 62.5px 0;
    border-top: solid 1px #dbdada;
  }
}
</style>
